/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const OAuthScopes = {
    REFRESH_TOKEN: 'REFRESH_TOKEN',
    USER_PROFILE_VIEW: 'USER_PROFILE_VIEW',
    USER_QUEST_PROGRESS_VIEW: 'USER_QUEST_PROGRESS_VIEW',
    USER_EVENT_SUBMISSION: 'USER_EVENT_SUBMISSION'
} as const;
export type OAuthScopes = typeof OAuthScopes[keyof typeof OAuthScopes];


export function instanceOfOAuthScopes(value: any): boolean {
    for (const key in OAuthScopes) {
        if (Object.prototype.hasOwnProperty.call(OAuthScopes, key)) {
            if (OAuthScopes[key as keyof typeof OAuthScopes] === value) {
                return true;
            }
        }
    }
    return false;
}

export function OAuthScopesFromJSON(json: any): OAuthScopes {
    return OAuthScopesFromJSONTyped(json, false);
}

export function OAuthScopesFromJSONTyped(json: any, ignoreDiscriminator: boolean): OAuthScopes {
    return json as OAuthScopes;
}

export function OAuthScopesToJSON(value?: OAuthScopes | null): any {
    return value as any;
}

export function OAuthScopesToJSONTyped(value: any, ignoreDiscriminator: boolean): OAuthScopes {
    return value as OAuthScopes;
}

